/**
 * @desc 通过数量推送mq
 */
const URL = "/rantion-plat-data-flow";
import http, { updateResponse } from "@/http";
export function request(params: API.platDataFlow.amzMqPush.pushMqBySize.Params, options?: any) {
  return updateResponse(
    http(URL + `/mqPush/pushMqBySize`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
